/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Uniqueworkplace_Tokyo1Inputs */

const ja_careers_uniqueworkplace_tokyo1 = /** @type {(inputs: Careers_Uniqueworkplace_Tokyo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームが人気な東京の中心で、成長を継続`)
};

const en_careers_uniqueworkplace_tokyo1 = /** @type {(inputs: Careers_Uniqueworkplace_Tokyo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Born, raised and thriving in the heart of game crazy Tokyo.`)
};

/**
* | output |
* | --- |
* | "Born, raised and thriving in the heart of game crazy Tokyo." |
*
* @param {Careers_Uniqueworkplace_Tokyo1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_uniqueworkplace_tokyo1 = /** @type {((inputs?: Careers_Uniqueworkplace_Tokyo1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Uniqueworkplace_Tokyo1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_uniqueworkplace_tokyo1(inputs)
	return en_careers_uniqueworkplace_tokyo1(inputs)
});
export { careers_uniqueworkplace_tokyo1 as "careers_uniqueWorkplace_tokyo" }